<template>
  <section class="blog-breadcrumb" resmed-component-name="blog-breadcrumb">
    <div class="component">
      <div class="container">
        <span>
          <a
            :href="address"
            class="d-inline"
            @click="onBreadcrumbClick('Support', address, 0)"
          >Support</a>

          <template v-if="tag && origin === 'single'">
            <span class="caret">></span>
            <p class="d-inline">{{ tag[Object.keys(this.tag)[0]] }}</p>
          </template>

          <span class="caret">></span>
          <span class="title">{{ title }}</span>
        </span>
      </div>
    </div>
  </section>
</template>

<script>
import { mapMutations } from 'vuex';
import { track_hyperlink_click } from "../../analytics/events";

export default {
  name: "blog-breadcrumb",
  props: {
    title: {
      type: String,
    },
    origin: {
      type: String,
      default() {
        return "archive";
      },
    },
  },
  data() {
    return {
      address: `${window.location.origin}/${this.$route.params.region}`,
      tag: JSON.parse(localStorage.getItem("sleep-blog-query-tag")),
    };
  },
  created() {
    bus.$emit("navigation:reversed", true);
    this.setShowLinks(true);
  },
  methods: {
    ...mapMutations(['setShowLinks']),
    onBreadcrumbClick(label, url, position) {
      track_hyperlink_click({
        clicked_area: "breadcrumb",
        component_name: "blog-breadcrumb",
        component_variant: this.origin || "archive",
        clicked_text: label,
        clicked_url: url,
        link_type: "internal",
        position,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.blog-breadcrumb {
  padding-top: 116px;
}

.component {
  padding: 1.625rem;
  background-color: rgba($cc-resmed-grey-15, 0.75);

  a {
    color: inherit;
  }

  .caret {
    margin: 0 0.5rem;
    transform: translateY(1px);
    display: inline-block;
  }

  .title {
    @extend %body-normal-bold;
  }
}
</style>